<template>
  <div class="s-act">
    <slot></slot>
    <img v-if="mainImg" :src="mainImg" alt="" class="main-img">
    <div class="progress-main">
      <div class="progress-top">
<!--        <div class="award-list"></div>-->
        <div v-for="(item,index) in act2" :key="index" class="award-list">
          <div v-if="item.materials && item.status === 0" class="award-item">
            <img :src="item.materials[0].icon" alt="" class='award-img'/>
            <div class="bottom-text">未开始</div>
          </div>
          <div v-if="item.materials && item.status === 1" class="award-item">
            <img  :src="item.materials[0].icon" alt="" class='award-img'/>
            <div class="bottom-text">待解锁</div>
          </div>
          <img v-if="item.materials && item.status === 2" :src="item.materials[0].icon" alt="" class='award-img' @click="receiveAward(item)"/>
          <div v-if="item.materials && item.status === 3" class="award-item">
            <img  :src="item.materials[0].icon" alt="" class='award-img'/>
            <div class="bottom-text">已领取</div>
          </div>
          <div v-if="item.materials && item.status === 4" class="award-item">
            <img  :src="item.materials[0].icon" alt="" class='award-img'/>
            <div class="bottom-text">已结束</div>
          </div>
          <div v-if="item.materials" class="award-name" :style="{color:textColor}">{{item.materials[0].name}}*{{item.materials[0].amount}}</div>
        </div>
      </div>
      <div class="progress-bottom">
        <div class="progress-line" :style="{width: progressWidthReal, height: allProgressHeight, backgroundColor: allProgressColor}">
          <div class="progress-already" :style="{backgroundColor: awardProgressColor, width: progressWidthCon, height: awardProgressHeight}"></div>
        </div>
<!--        <div class="award-num-list"></div> -->
        <div v-for="(item,index) in act2" :key="index" class="award-num-list">
          <div v-if="item.condition_ret" class="award-num" :style="{backgroundColor: circleProgressColor, color: circleProgressValueColor}">{{item.condition_ret.expect_val}}</div>
        </div>
      </div>
    </div>
    <div class="btn-lottery">
      <img :src="btnLotteryOne.src" alt="" :style="{ ...getSize(btnSize), ...btnLotteryOne.style }" @click="lotteryFun(1)"/>
      <img :src="btnLotteryTen.src" alt="" :style="{ ...getSize(btnSize), ...btnLotteryTen.style }" @click="lotteryFun(10)"/>
    </div>
    <div class="current-point" :style="{...getPosition(currentPoint), color: textColor }">当前进度值：{{currentProgress}}</div>
    <SFiveModalConfirm ref="SFiveModalConfirm"></SFiveModalConfirm>
    <SFiveModalReceive ref="SFiveModalReceive"></SFiveModalReceive>
  </div>
</template>

<script>
import { getPosition, getSize } from '../utils'
import SFiveModalConfirm from '@/components/BuilderComponents/FiveInOne/_components/FiveModalConfirm.vue'
import SFiveModalReceive from '@/components/BuilderComponents/FiveInOne/_components/FiveModalReceive.vue'

export default {
  name: 'SActLottery',
  components: { SFiveModalConfirm, SFiveModalReceive },
  props: {
    request: {
      type: Function
    },
    activityId1: {
      type: String,
      default: ''
    },
    activityId2: {
      type: String,
      default: ''
    },
    mainImg: {
      type: String,
      required: true
    },
    allProgressColor: {
      type: String,
      required: true
    },
    allProgressHeight: {
      type: String,
      default: '5px'
    },
    awardProgressColor: {
      type: String,
      required: true
    },
    awardProgressHeight: {
      type: String,
      default: '5px'
    },
    circleProgressColor: {
      type: String,
      required: true
    },
    circleProgressValueColor: {
      type: String,
      required: true
    },
    textColor: {
      type: String,
      required: true
    },
    currentPoint: {
      type: String,
      required: true
    },
    btnSize: {
      type: String
    },
    btnLotteryOne: {
      type: Object,
      required: true
    },
    btnLotteryTen: {
      type: Object,
      required: true
    }
  },
  inject: {
    eventBus: {
      default: null
    },
    $MainWrap: {
      default: null
    }
  },
  data () {
    return {
      act2: [],
      point: 0,
      progressWidth: 1250,
      currentProgress: 0
    }
  },

  computed: {
    requestAPI () {
      // eslint-disable-next-line no-undef
      return this.request ? this.request : $request
    },
    progressWidthReal () {
      return this.progressWidth / 19.20 + 'vw'
    },
    progressWidthCon () {
      const widthCon = this.progressWidth / 19.20
      const newWidth = widthCon / (this.act2.length - 1) * this.point
      const width = newWidth > this.progressWidth ? this.progressWidth : newWidth
      return width + 'vw'
    }
  },
  mounted () {
    // 登录成功操作添加
    if (this.eventBus) {
      this.eventBus.on('loginSuccess', this.init)
      // 登出操作添加
      this.eventBus.on('signOut', this.reset)
    }
    // 初始化登录判断
    // eslint-disable-next-line no-undef
    $checkLogin()
    this.init()
  },
  watch: {
    activityId1 (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.init()
      }
    },
    activityId2 (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.init()
      }
    }
  },
  methods: {
    getSize,
    getPosition,
    // 获取初始化状态
    init: function () {
      // 获取当前进度条
      this.requestAPI({
        url: '/v1/uni/info',
        method: 'get',
        params: { a_id: this.activityId2 }
      }).then((data) => {
        this.act2 = data.groups || []
        data.groups.forEach((item, index) => {
          if (item.condition_ret.actual_val >= item.condition_ret.expect_val) {
            this.point = index
          }
        })

        const flag = data.groups.some((item) => {
          if (item.condition_ret.actual_val < item.condition_ret.expect_val) {
            this.currentProgress = item.condition_ret.actual_val
            return true
          }
          return false
        })
        if (!flag) {
          this.currentProgress = data.groups[data.groups.length - 1].condition_ret.actual_val
        }
        // 检查是否处于活动时间
        console.log('> 抽奖活动 检查时间')
        this.$MainWrap.checkStartEnd(data.start_at, data.end_at)
      }).catch((err) => {
        this.$message.error(err.msg || '系统错误')
      })
    },
    lotteryFun (num) {
      // eslint-disable-next-line no-undef
      if (!$checkLogin()) return
      // 判断进度是否达到150
      if (this.act2[this.act2.length - 1].condition_ret.actual_val === this.act2[this.act2.length - 1].condition_ret.expect_val) {
        this.$MainWrap.confirm({ content: '进度已达上限', cancelBtnText: '关闭', confirmBtnText: '' })
        return
      }
      this.requestAPI({
        url: '/v1/uni/multiLottery',
        method: 'get',
        params: { a_id: this.activityId1, count: num }
      }).then((res) => {
        let name = ''
        let count = 0
        res.forEach((item) => {
          item.materials.forEach((data) => {
            name = data.name
            count = count + data.amount
          })
        })
        this.$MainWrap.confirm({ title: '恭喜你获得', content: name + '*' + count, cancelBtnText: '' })
        this.init()
      }).catch((err) => {
        this.$message.error(err.msg || '系统错误')
      })
    },
    receiveAward (item) {
      // 判断登录
      // eslint-disable-next-line no-undef
      if (!$checkLogin()) return
      if (item.status !== 2) {
        return
      }
      const params = {
        a_id: this.activityId2,
        g_id: item.id
      }
      this.requestAPI({
        url: '/v1/uni/receive',
        method: 'get',
        params
      }).then((data) => {
        if (data.success) {
          this.$MainWrap.openReceiveModal(item.materials)
          this.init()
        } else {
          this.$message.error(data.msg || '系统错误')
        }
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    // 重置
    reset () {
      this.point = 0
      this.currentProgress = 0
      this.init()
    }
  },
  beforeDestroy () {
    if (this.eventBus) {
      // console.log('> SActFreeLegendWeapon  取消登录监听')
      this.eventBus.off('loginSuccess', this.init)
      this.eventBus.off('signOut', this.reset)
    }
  }
}
</script>

<style scoped lang="scss">
// 公共样式
.auto-bg {
  background-repeat: no-repeat;
  background-size: 100%;
}
.hv-highlight{
  cursor: pointer;
  &:hover{
    filter: brightness(1.2);
  }
}

// 内容样式
.s-act {
  width: 100%;
  height: 966px;
  position: relative;
  .main-img {
    width: 100%;
    height: 100%;
    display: block;
  }
  .progress-main{
    position: absolute;
    bottom: 20px;
    left: 100px;
    width: 1400px;
    height: 300px;
    .award-list,.award-num-list{
      position: relative;
      width: 100px;
      height: 100px;
    }
    .progress-top{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      margin-bottom: 50px;
      cursor: pointer;
      .award-item{
        position: relative;
        width: 100%;
        height: 100%;
      }
      .award-img{
        width: 100%;
        height: 100%;
        border-radius: 4px;
        box-shadow: 0 0 5px #ccc;
        padding: 15px;
        background-color: rgba(0, 0, 0, 0.3);
        object-fit: contain;
      }
      .award-name{
        position: absolute;
        left: 50%;
        top: 120px;
        transform: translateX(-50%);
        -webkit-transform: translateX(-50%) ;
        -moz-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
        -o-transform: translateX(-50%);
        width: 100%;
        font-size: 16px;
        text-align: center;
      }
      .bottom-text{
        width: 100%;
        position: absolute;
        right: 0;
        bottom: 0;
        font-size: 18px;
        text-align: right;
        opacity: 0.6;
      }
    }
    .progress-bottom{
      display: flex;
      justify-content: space-between;
      position: relative;
      width: 100%;
      .progress-line{
        position: absolute;
        left: 75px;
        top: 50%;
        transform: translateY(-50%);
        -webkit-transform: translateY(-50%) ;
        // height: 5px;
        .progress-already{
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          -webkit-transform: translateY(-50%) ;
          // height: 5px;
        }
      }
      .award-num-list{
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2;
        .award-num{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          font-size: 24px;
          font-weight: bold;
        }
      }
    }
  }
  .btn-lottery{
   img{
     position: absolute;
     z-index: 2;
   }
  }
  .current-point{
    position: absolute;
    z-index: 2;
    font-size: 18px;
  }
}
</style>
